import React from 'react'
import { withRouter } from 'react-router-dom'
import { Button, Modal } from 'antd'
import styled from '@src/styled-components'
import I18n from '@src/i18n'
import Status from './Status'

class LinkButton extends React.Component<any, any> {
  constructor(props: any) {
    super(props)
    this.state = {
      disableOk: false,
      visible: false
    }
    this.setVisible = this.setVisible.bind(this)
    this.setDisableOk = this.setDisableOk.bind(this)

  }
  setDisableOk = (e: boolean) => {
    this.setState({ disableOk: e });
  }
  
  setVisible() {
    this.setState({ visible: !this.state.visible });
    if(this.state.disableOk && this.props.processType === 'scheduled'){
      this.props.loadScheduled()
    }
  }
  shouldComponentUpdate(nextProps: any, nextState: any) {
    if (nextState.disableOk !== this.state.disableOk || nextState.visible !== this.state.visible) {
      return true
    }
    return false

  }
  render() {
    const { history, route, ticket, item, processType } = this.props
    const { disableOk, visible } = this.state
    
    return <>
      <Button onClick={this.setVisible}>{this.props.children}</Button>
      <Modal
        onCancel={this.setVisible}
        destroyOnClose={true}
        visible={visible}
        footer={false}
        title={I18n.l('my_processes.modal.startProcess')}
      >
        <span>{item.name}<br /><Status processType={processType} userId={item.id} setDisable={this.setDisableOk} /></span>
        <Footer>
          <Button onClick={this.setVisible}>{I18n.l('common.cancel')}</Button>
          <Button onClick={() => {
            localStorage.setItem(ticket, item.id)
            history.push(route)
          }
          } type="primary" disabled={disableOk}>{I18n.l('common.start')}</Button>
        </Footer>
      </Modal>
    </>
  }
}

const LinkButtonWithRouter = withRouter(LinkButton)
export default LinkButtonWithRouter

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
    button{
      margin-left: 10px
    }
`;